<!-- Left nav: hamburger + nav links -->
<ul class="navbar-nav">
    <li class="nav-item">
        <a class="nav-link amt-hamburger" (click)="onToggleMenuSidebar()" role="button">
            <i class="fas fa-bars"></i>
        </a>
    </li>
</ul>

<!-- Center: Logo & Brand -->
<div class="amt-navbar-brand">
    <img src="assets/img/AMT.png" alt="AMT Logo" class="amt-navbar-logo" />
    <span class="amt-navbar-title d-none d-md-inline">Aathreya Machine Tools</span>
</div>

<!-- Right nav: notifications + logout -->
<ul class="navbar-nav ml-auto amt-right-nav">
    <li class="nav-item">
        <a class="nav-link amt-logout-btn" (click)="logout()" role="button" title="Logout">
            <i class="fas fa-sign-out-alt"></i>
            <span class="d-none d-md-inline ml-1">Logout</span>
        </a>
    </li>
</ul>